module.exports = __webpack_public_path__ + "static/img/hai.fb4833e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hai.png
// module id = PdA0
// module chunks = 3